import { _get } from "./Axios";

export default class TrackingKpiApi {
  static get(id) {
    return _get("kpi/tracking/" + id);
  }

  static getByParam(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("kpi/tracking?" + params);
  }
}
